import "./PatientInsuranceConflictComponent.scss";
import TableWrapperV2Component from "../table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../constants";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {ITableColumn} from "../../models/table.model";
import commonService from "../../services/common.service";
import ChipComponent from "../chip/ChipComponent";
import TooltipComponent from "../tooltip/tooltipComponent";
import IconButtonComponent from "../core/icon-button/IconButtonComponent";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AutoCompleteDropdownComponent from "../core/auto-complete-dropdown/autoCompleteDropdownComponent";
import CommonService from "../../services/common.service";
import ButtonComponent from "../core/button/ButtonComponent";

interface PatientInsuranceConflictComponentProps {
    bulkPatientID: string | number;
}

interface InsuranceDetails {
    id?: number | string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    insuranceCompany: string;
    policyNumber: string;
    relationship: string;
    networkPlanName: string;
    effectiveDate: string;
    clearingHouse: string;
    clearingHouseCode: string;
    clearingHouseId: number;
    payerId: string;
    CPID: string;
    type: string;
    groupId: string | null;
}

interface PatientDetailsType {
    firstName: string;
    middleName: string;
    lastName: string;
    dateOfBirth: string;
    gender: string;
    race: string;
    ethnicity: string;
    mobileNumber: string;
    addressLine1: string;
    addressLine2: string;
    zipcode: string;
    state: string;
    city: string;
    emailId: string;
    validationErrors: Record<string, any>;  // Assuming validationErrors can be an object with any keys and values
    patientId: number;
}

interface ConflictInsuranceListType {
    patientDetails: {
        patientDetails: PatientDetailsType;
        existingInsuranceList: InsuranceDetails[];
        csvInsurances: InsuranceDetails[];
    };
    isUpdated: boolean;
    isLoading?: boolean;
    id: string | number;
    selectedInsurances?: InsuranceDetails[];//for internal state management only
}

interface conflictInsuranceType {
    patientId: string | number;
    insuranceDetails: InsuranceDetails[];
}

interface updatePatientInsurancePayloadType {
    batchOrderPatientId: number | string,
    patientId: number | string,
    insuranceDetails: InsuranceDetails[]
}

// const patientInsuranceDataDummy: ConflictInsuranceListType[] = Array.from({length: 10}).map((_, index) => {
//     return {
//         "patientDetails": {
//             "patientDetails": {
//                 "firstName": "conflict",
//                 "middleName": "",
//                 "lastName": `patient ${index + 1}`,
//                 "dateOfBirth": "2024-12-12",
//                 "gender": "Male",
//                 "race": "Asian",
//                 "ethnicity": "ccece",
//                 "mobileNumber": "1111111111",
//                 "addressLine1": "Texas",
//                 "addressLine2": "Street",
//                 "zipcode": "99663",
//                 "state": "cecece",
//                 "city": "Seldovia",
//                 "emailId": "johndoe@gmail.com",
//                 "validationErrors": {},
//                 "patientId": 15 + index + 400
//             },
//             "existingInsuranceList": [
//                 {
//                     "id": 38,
//                     "firstName": "John conflict 1",
//                     "middleName": null,
//                     "lastName": "Toki",
//                     "dateOfBirth": "2001-12-26",
//                     "payerId": "13413",
//                     "patientId": 15,
//                     "type": "Professional",
//                     "insuranceCompany": "WIN Healthcare (Woman's Integrated Network)",
//                     "insurancePlan": null,
//                     "policyNumber": "6666hGGs",
//                     "relationship": "Self",
//                     "frontImage": null,
//                     "backImage": null,
//                     "enbotDetails": {
//                         "status": false,
//                         "enb_check": "failed",
//                         "message": "default",
//                         "isVerified": false
//                     },
//                     "isEnbotChecked": false,
//                     "isSameName": false,
//                     "networkPlanName": "WIN Healthcare (Woman's Integrated Network)",
//                     "groupName": null,
//                     "groupNetwork": null,
//                     "effectiveDate": "2001-12-26",
//                     "ipaMedicalGroupName": null,
//                     "clearingHouse": "Change Healthcare",
//                     "clearingHouseCode": "change_healthcare",
//                     "clearingHouseId": 1,
//                     "CPID": "5710",
//                     "groupId": null,
//                     "createdAt": "2024-12-16T18:33:32.562Z",
//                     "updatedAt": "2024-12-16T18:33:32.562Z"
//                 },
//                 {
//                     "id": 39,
//                     "firstName": "John conflict 2",
//                     "middleName": null,
//                     "lastName": "Toki",
//                     "dateOfBirth": "2001-12-26",
//                     "payerId": "83077",
//                     "patientId": 15,
//                     "type": "Professional",
//                     "insuranceCompany": "Advantek Benefit Administrators",
//                     "insurancePlan": null,
//                     "policyNumber": "6666hGGs",
//                     "relationship": "Self",
//                     "frontImage": null,
//                     "backImage": null,
//                     "enbotDetails": {
//                         "status": false,
//                         "enb_check": "failed",
//                         "message": "default",
//                         "isVerified": false
//                     },
//                     "isEnbotChecked": false,
//                     "isSameName": false,
//                     "networkPlanName": "aetna",
//                     "groupName": null,
//                     "groupNetwork": null,
//                     "effectiveDate": "2001-12-26",
//                     "ipaMedicalGroupName": null,
//                     "clearingHouse": "Change Healthcare",
//                     "clearingHouseCode": "change_healthcare",
//                     "clearingHouseId": 1,
//                     "CPID": "6122",
//                     "groupId": null,
//                     "createdAt": "2024-12-16T18:33:32.781Z",
//                     "updatedAt": "2024-12-16T18:33:32.781Z"
//                 },
//                 {
//                     "id": 40,
//                     "firstName": "John conflict 3",
//                     "middleName": null,
//                     "lastName": "Toki",
//                     "dateOfBirth": "2001-12-26",
//                     "payerId": "2020E",
//                     "patientId": 15,
//                     "type": "Professional",
//                     "insuranceCompany": "2020 Eyecare",
//                     "insurancePlan": null,
//                     "policyNumber": "6666hGGs",
//                     "relationship": "Self",
//                     "frontImage": null,
//                     "backImage": null,
//                     "enbotDetails": {
//                         "status": false,
//                         "enb_check": "failed",
//                         "message": "default",
//                         "isVerified": false
//                     },
//                     "isEnbotChecked": false,
//                     "isSameName": false,
//                     "networkPlanName": "aetna",
//                     "groupName": null,
//                     "groupNetwork": null,
//                     "effectiveDate": "2001-12-26",
//                     "ipaMedicalGroupName": null,
//                     "clearingHouse": "Change Healthcare",
//                     "clearingHouseCode": "change_healthcare",
//                     "clearingHouseId": 1,
//                     "CPID": "8215",
//                     "groupId": null,
//                     "createdAt": "2024-12-16T18:33:33.004Z",
//                     "updatedAt": "2024-12-16T18:33:33.004Z"
//                 }
//             ],
//             "csvInsurances": [
//                 {
//                     "firstName": "John conflict 1",
//                     "lastName": "Toki",
//                     "dateOfBirth": "2001-12-26",
//                     "insuranceCompany": "WIN Healthcare (Woman's Integrated Network)",
//                     "policyNumber": "6666hGGs",
//                     "relationship": "Self",
//                     "networkPlanName": "WIN Healthcare (Woman's Integrated Network)",
//                     "effectiveDate": "2001-12-26",
//                     "clearingHouse": "Change Healthcare",
//                     "clearingHouseCode": "change_healthcare",
//                     "clearingHouseId": 1,
//                     "payerId": "13413",
//                     "CPID": "5710",
//                     "type": "Professional",
//                     "groupId": null,
//                     "enbotDetails": {
//                         "status": false,
//                         "enb_check": "failed",
//                         "message": "default",
//                         "isVerified": false
//                     }
//                 },
//                 {
//                     "firstName": "John conflict 2",
//                     "lastName": "Toki",
//                     "dateOfBirth": "2001-12-26",
//                     "insuranceCompany": "Advantek Benefit Administrators",
//                     "policyNumber": "6666hGGs",
//                     "relationship": "Self",
//                     "networkPlanName": "aetna",
//                     "effectiveDate": "2001-12-26",
//                     "clearingHouse": "Change Healthcare",
//                     "clearingHouseCode": "change_healthcare",
//                     "clearingHouseId": 1,
//                     "payerId": "83077",
//                     "CPID": "6122",
//                     "type": "Professional",
//                     "groupId": null,
//                     "enbotDetails": {
//                         "status": false,
//                         "enb_check": "failed",
//                         "message": "default",
//                         "isVerified": false
//                     }
//                 },
//                 {
//                     "firstName": "John conflict 3",
//                     "lastName": "Toki",
//                     "dateOfBirth": "2001-12-26",
//                     "insuranceCompany": "2020 Eyecare",
//                     "policyNumber": "6666hGGs",
//                     "relationship": "Self",
//                     "networkPlanName": "aetna",
//                     "effectiveDate": "2001-12-26",
//                     "clearingHouse": "Change Healthcare",
//                     "clearingHouseCode": "change_healthcare",
//                     "clearingHouseId": 1,
//                     "payerId": "2020E",
//                     "CPID": "8215",
//                     "type": "Professional",
//                     "groupId": null,
//                     "enbotDetails": {
//                         "status": false,
//                         "enb_check": "failed",
//                         "message": "default",
//                         "isVerified": false
//                     }
//                 }
//             ]
//         },
//         isUpdated: false,
//         isLoading: false,
//         id: index + 909
//     }
// })
const PatientInsuranceConflictComponent = (props: PatientInsuranceConflictComponentProps) => {
    const {bulkPatientID} = props;
    //list of patient with conflict with insurances
    const [patientInsuranceData, setPatientInsuranceData] = useState<ConflictInsuranceListType[]>([]);
    //list of patient id and selected insurances' data.
    const [conflictInsurance, setConflictInsurance] = useState<conflictInsuranceType[]>([]);

    useEffect(() => {
        console.log({conflictInsurance})
    }, [conflictInsurance])


    useEffect(() => {
        if (patientInsuranceData?.length > 0) {
            const updatedConflictInsuranceData = patientInsuranceData.map(({
                                                                               patientDetails,
                                                                               isUpdated,
                                                                               selectedInsurances
                                                                           }) => {
                const patientId = patientDetails?.patientDetails?.patientId;
                const insuranceDetails = isUpdated ? patientDetails.existingInsuranceList : selectedInsurances || [];

                return {patientId, insuranceDetails};
            });

            setConflictInsurance(updatedConflictInsuranceData);
        }
    }, [patientInsuranceData]);

    // useEffect(() => {
    //     console.log({patientInsuranceData})
    // }, [patientInsuranceData]);

    const tablePayload = useMemo(() => ({
        sessionId: bulkPatientID
    }), [bulkPatientID])

    const extractUniqueInsurance = useCallback((existingInsurance: InsuranceDetails[], csvInsurance: Omit<InsuranceDetails, 'id'>[]) => {
        // Create a Set to store unique keys (combination of insuranceCompany, relationship, and clearingHouse)
        const uniqueInsuranceSet = new Set();

        // Start with existing insurance array, and mark each unique combination
        const uniqueInsurance = existingInsurance.filter(insurance => {
            const key = `${insurance.insuranceCompany}-${insurance.relationship}-${insurance.clearingHouse}`;
            if (uniqueInsuranceSet.has(key)) {
                return false; // Skip duplicate
            }
            uniqueInsuranceSet.add(key); // Add to set
            return true;
        });

        // Now, process the csvInsurance and add unique entries
        csvInsurance.forEach(insurance => {
            const key = `${insurance.insuranceCompany}-${insurance.relationship}-${insurance.clearingHouse}`;
            if (!uniqueInsuranceSet.has(key)) {
                uniqueInsurance.push(insurance); // Add the new unique insurance
                uniqueInsuranceSet.add(key); // Mark this combination as processed
            }
        });

        return uniqueInsurance;
    }, []);

    useEffect(() => {
        console.log({patientInsuranceData})
    }, [patientInsuranceData]);
    const handleResolvePatientInsurance = useCallback((payload: updatePatientInsurancePayloadType) => {
        //don't send insurance id from payload.insurances array
        const currentPatientId = payload.patientId;
        const updateLoadingState = (isLoading: boolean, isUpdated: boolean, updatedInsurances?: InsuranceDetails[]) => {
            const updatedPatientInsuranceData = [...patientInsuranceData];
            const updateIndex = updatedPatientInsuranceData.findIndex((patient) => +(patient.patientDetails?.patientDetails?.patientId) === +(currentPatientId))
            if (updateIndex > -1) {
                const oldData = updatedPatientInsuranceData[updateIndex];
                oldData.isLoading = isLoading;
                oldData.isUpdated = isUpdated;
                if (isLoading) {
                    oldData.selectedInsurances = payload.insuranceDetails
                } else {
                    if (updatedInsurances) oldData.patientDetails.existingInsuranceList = updatedInsurances;
                    delete oldData.selectedInsurances
                }
                updatedPatientInsuranceData[updateIndex] = oldData;
                setPatientInsuranceData([...updatedPatientInsuranceData]);
            }
        }

        updateLoadingState(true, false);
        const modPayload = {
            ...payload,
            insuranceDetails: payload.insuranceDetails.map((insurance) => {
                // remove id from payload
                delete insurance.id
                return insurance
            })
        }
        CommonService._patient.resolveBulkPatientInsurances(modPayload).then(({data, message}: {
            data: conflictInsuranceType,
            message?: string
        }) => {
            updateLoadingState(false, true, data.insuranceDetails);
            CommonService._alert.showToast(message || "Insurances updated successfully", "success")
        }).catch((err) => {
            updateLoadingState(false, false);
            CommonService._alert.showToast(err.error || "Unable to update insurances", 'error')
        })
    }, [patientInsuranceData])


    const patientInsuranceConflictColumns: ITableColumn[] = useMemo(() => [
        {
            id: 'patientDetails.firstName', label: 'First Name', isDefaultColumn: true,
            content: (item: ConflictInsuranceListType) => (
                <>
                    {item?.patientDetails?.patientDetails?.firstName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientDetails?.firstName) : '-'}
                </>
            )
        },
        // {
        //     id: 'patientDetails.middleName',
        //     label: 'Patient Middle Name',
        //     content: (item: ConflictInsuranceListType) => item?.patientDetails?.patientDetails?.middleName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.middleName) : '-'
        // },
        {
            id: 'patientDetails.lastName', label: 'Last Name', isDefaultColumn: true,
            content: (item: ConflictInsuranceListType) => (
                <>
                    {item?.patientDetails?.patientDetails?.lastName ? commonService.capitalizeFirstLetterOfEachWord(item?.patientDetails?.patientDetails?.lastName) : '-'}
                </>
            )
        },
        {
            id: "emailId", label: "Email ID", align: 'center',
            isDefaultColumn: true,
            width: "200",
            content: (item: ConflictInsuranceListType) => (
                <div className={"ellipses-text"}>
                    {item?.patientDetails?.patientDetails?.emailId ? item?.patientDetails?.patientDetails?.emailId : '-'}
                </div>
            )
        },
        // Additional columns based on dataColumns
        {
            id: 'attached-insurance',
            label: 'Attached Insurances',
            align: 'center',
            width: '150',
            content: (item: ConflictInsuranceListType) => {
                const insuranceList = item?.patientDetails?.existingInsuranceList?.map(({
                                                                                            insuranceCompany = '',
                                                                                            relationship = ''
                                                                                        }) => (
                    <ChipComponent
                        label={`${insuranceCompany} - (${relationship})`.trim()}
                    />
                ));
                return <>
                    <TooltipComponent placement={'left'} arrow tooltip={insuranceList}>
                        <div>
                            <IconButtonComponent
                                size={"small"}
                                color={"primary"}
                                position={"end"}>
                                <VisibilityIcon/>
                            </IconButtonComponent>
                        </div>
                    </TooltipComponent>
                </>
            }
        },
        {
            id: 'patientDetails.insurance',
            label: 'Insurance',
            isDefaultColumn: true,
            fixed: 'right',
            width: 490,
            content: (item: ConflictInsuranceListType) => {
                const selectedPatientInsurances = conflictInsurance.find((patient) => patient.patientId === item.patientDetails.patientDetails?.patientId)
                return <>
                    <AutoCompleteDropdownComponent
                        freeSolo
                        name={"insurance"}
                        label={'Select Insurance'}
                        placeholder={'Select Lab Type'}
                        size={"small"}
                        className={"mrg-bottom-0"}
                        // valueKey={'insuranceCompany'}
                        multiple={true}
                        renderOption={(props, option: InsuranceDetails) => (
                            <li {...props}>
                                <div>
                                    <strong>{option.insuranceCompany}</strong>
                                    <div>{`Relationship: ${option.relationship || 'No Relationship'}`}</div>
                                    <div>{`Clearing House: ${option.clearingHouse || 'No Clearing House'}`}</div>
                                    <div>{`Payer Id: ${option.payerId || 'No Payer ID'}`}</div>
                                </div>
                            </li>
                        )}
                        disabled={item?.isUpdated || item.isLoading}
                        data={extractUniqueInsurance(item?.patientDetails?.existingInsuranceList, item?.patientDetails?.csvInsurances)}
                        getOptionLabel={(option) => {
                            const {insuranceCompany = '', relationship = ''} = option || {};
                            return `${insuranceCompany} - (${relationship})`.trim();
                        }}
                        getOptionDisabled={(option => option.disabled)}
                        onSelectUpdate={(newValue: any) => {
                            if (newValue.length > 3) {
                                CommonService._alert.showToast("Maximum 3 can be selected at time", 'info')
                                return;
                            }
                            setConflictInsurance((prev) => {
                                const setNewValue = {
                                    patientId: item.patientDetails?.patientDetails?.patientId,
                                    insuranceDetails: newValue
                                };
                                const index = prev.findIndex((patient) => patient.patientId === item.patientDetails?.patientDetails?.patientId);
                                if (index > -1) {
                                    prev[index].insuranceDetails = newValue;
                                    return [...prev];
                                }
                                return [...prev, setNewValue]
                            });
                        }}
                        value={selectedPatientInsurances?.insuranceDetails || []}
                    />
                </>
            }
        },
        {
            id: 'actions',
            label: 'Action',
            isDefaultColumn: true,
            fixed: 'right',
            width: 120,
            content: (item: ConflictInsuranceListType, index: number) => {
                const selectedPatientInsurances = conflictInsurance.find((patient) => patient.patientId === item.patientDetails.patientDetails?.patientId)

                return <>
                    <ButtonComponent variant={'contained'}
                                     disabled={item?.isUpdated || (selectedPatientInsurances && selectedPatientInsurances?.insuranceDetails?.length < 1)}
                                     isLoading={item.isLoading}
                                     handleClick={() => {
                                         if (selectedPatientInsurances?.insuranceDetails) {
                                             const payload: updatePatientInsurancePayloadType = {
                                                 batchOrderPatientId: item?.id,
                                                 patientId: item?.patientDetails?.patientDetails?.patientId,
                                                 insuranceDetails: selectedPatientInsurances?.insuranceDetails,
                                             };
                                             // console.log({payload}, 'this is the item')
                                             handleResolvePatientInsurance(payload);
                                         }
                                     }}>Update</ButtonComponent>
                </>
            }
        }
    ], [conflictInsurance, extractUniqueInsurance, handleResolvePatientInsurance])

    return (
        <div className={'patient-insurance-conflict-component'}>
            <div className={'clearing-house-list-container table-list-container'}>
                <TableWrapperV2Component
                    isPaginated={true}
                    columns={patientInsuranceConflictColumns}
                    url={APIConfig.GET_BULK_PATIENT_CONFLICT_PATIENTS.URL}
                    method={APIConfig.GET_BULK_PATIENT_CONFLICT_PATIENTS.METHOD}
                    extraPayload={tablePayload}
                    isColumnFilterVisible={false}
                    isStickyHeader={true}
                    onDataLoad={(value: any) => {
                        setPatientInsuranceData(value?.length > 0 ? value : [])
                    }}
                />
                {/*<div className={'t-table-container'}>*/}
                {/*    <TableV2Component*/}
                {/*        columns={patientInsuranceConflictColumns}*/}
                {/*        data={patientInsuranceData}*/}
                {/*        loading={false}*/}
                {/*        errored={false}*/}
                {/*        fixedHeader={true}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
        </div>
    );

};

export default PatientInsuranceConflictComponent;
